import React from "react";
import { ShareApplicationPerson } from "@/types/ShareApplication";
import { Footer, ActionButtons } from "@ucl/library";
import { UserAccountStatus } from "@/types/enums";
import "./ShareApplicationInviteLink.scss";
import {
  LinkedAccountComponent,
  UnlinkedAccountComponent,
  UnlinkedWithPotentialUserComponent,
  InviteCreatedAccountComponent,
  InviteSentAccountComponent,
  InviteExpiredAccountComponent,
} from "./UserAccountStatusComponents";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

export interface ShareApplicationInviteLinkProps {
  person: ShareApplicationPerson;
  financialApplicationId?: string;
  onBack: () => void;
  onUserLinked?: () => void;
}

export const ShareApplicationInviteLink: React.FC<ShareApplicationInviteLinkProps> = ({
  person,
  financialApplicationId,
  onBack,
  onUserLinked,
}) => {
  const renderUserAccountStatusComponent = () => {
    switch (person.userAccountStatus) {
      case UserAccountStatus.Linked:
        return (
          <LinkedAccountComponent person={person} financialApplicationId={financialApplicationId} />
        );
      case UserAccountStatus.Unlinked:
        // Check if there's a potential user ID for unlinked accounts
        if (person.potentialUserId) {
          return (
            <UnlinkedWithPotentialUserComponent
              person={person}
              financialApplicationId={financialApplicationId}
              onUserLinked={onUserLinked}
            />
          );
        } else {
          return (
            <UnlinkedAccountComponent
              person={person}
              financialApplicationId={financialApplicationId}
            />
          );
        }
      case UserAccountStatus.InviteCreated:
        return (
          <InviteCreatedAccountComponent
            person={person}
            financialApplicationId={financialApplicationId}
          />
        );
      case UserAccountStatus.InviteSent:
        return (
          <InviteSentAccountComponent
            person={person}
            financialApplicationId={financialApplicationId}
          />
        );
      case UserAccountStatus.InviteExpired:
        return (
          <InviteExpiredAccountComponent
            person={person}
            financialApplicationId={financialApplicationId}
          />
        );
      default:
        return <div>Unknown user account status</div>;
    }
  };

  return (
    <div className="share-application-invite-link">
      <div className="share-application-invite-link__content">
        {renderUserAccountStatusComponent()}
      </div>

      <Footer className="share-application-invite-link__footer">
        <ActionButtons
          actions={[
            {
              text: "Back",
              minimal: true,
              iconProps: {
                icon: faArrowLeft,
              },
              isPrimary: false,
              // color: "forest-green",
              onActionClick: onBack,
            },
          ]}
        />
      </Footer>
    </div>
  );
};

export default ShareApplicationInviteLink;
